import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { AiIntegrationView } from "../../../useSearchAiIntegrations/gql";

const IntegrationsAiTableProviderCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AiIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{item.provider}</TableCellText>
    </TableSimpleCell>
  );
};

export default IntegrationsAiTableProviderCell;
